import * as yup from 'yup';

import { normalizeHtmlContent } from '@hunkware/shared/utils';

export const textEditorFormValidationSchema = yup.object({
  text: yup
    .string()
    .trim()
    .transform(value => {
      const transformedValue = normalizeHtmlContent(value);

      return transformedValue;
    }),
});
